import { render, staticRenderFns } from "./UserPicklDetailsPopup.vue?vue&type=template&id=47967786&scoped=true&"
import script from "./UserPicklDetailsPopup.vue?vue&type=script&lang=js&"
export * from "./UserPicklDetailsPopup.vue?vue&type=script&lang=js&"
import style0 from "./UserPicklDetailsPopup.vue?vue&type=style&index=0&id=47967786&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47967786",
  null
  
)

export default component.exports